"use client";

import React from "react";
import { FaWhatsapp } from "react-icons/fa";

// Internal redirect so crawlers see our domain (200/302) instead of wa.me (429 rate limit)
const WHATSAPP_LINK = "/go/whatsapp";

const WhatsAppButton = () => {
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    window.open(WHATSAPP_LINK, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="fixed right-4 top-1/2 -translate-y-1/2 z-[9990]">
      <div className="relative flex items-center justify-center">

        {/* Ripple Rings */}
        <span className="absolute w-20 h-20 rounded-full border border-green-400 animate-[ping_2.5s_linear_infinite]" />
        <span className="absolute w-20 h-20 rounded-full border border-green-400 animate-[ping_2.5s_linear_infinite] [animation-delay:0.8s]" />
        <span className="absolute w-20 h-20 rounded-full border border-green-400 animate-[ping_2.5s_linear_infinite] [animation-delay:1.6s]" />

        {/* Button */}
        <a
          href={WHATSAPP_LINK}
          target="_blank"
          rel="noopener noreferrer nofollow"
          onClick={handleClick}
          className="relative flex items-center justify-center bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-xl"
          title="Chat with us on WhatsApp"
          aria-label="Chat with us on WhatsApp"
        >
          {/* Ding-dong icon */}
          <FaWhatsapp
            size={28}
            className="animate-[dingdong_2s_ease-in-out_infinite]"
          />
        </a>

      </div>

      {/* Local animation (no Tailwind config needed) */}
      <style jsx>{`
        @keyframes dingdong {
          0%, 100% { transform: rotate(0deg); }
          10% { transform: rotate(-15deg); }
          20% { transform: rotate(15deg); }
          30% { transform: rotate(-10deg); }
          40% { transform: rotate(10deg); }
          50% { transform: rotate(0deg); }
        }
      `}</style>
    </div>
  );
};

export default React.memo(WhatsAppButton);